export const requiredValidator = (value: string) => value ? "" : "Required";